import { numberFormatter } from "@/lib/utils";
import { PassCategory } from "src/api/membership";
import { SourceTypeWithString, SubjectsWithString } from "src/api/product";
export const isCategoryIncludesExpert = (category)=>{
    return category.includes(PassCategory.Expert);
};
export const getPassScope = (pass)=>{
    switch(pass.category){
        case PassCategory.Solvookplus:
        case PassCategory.Subscription:
            var _pass_subject, _pass_unavailableAuthorNames;
            return [
                {
                    type: "과목",
                    value: (_pass_subject = pass.subject) !== null && _pass_subject !== void 0 ? _pass_subject : SubjectsWithString[pass.subjectCode]
                },
                {
                    type: "과정",
                    value: pass.availableCurriculumNames
                },
                {
                    type: "제외저자",
                    value: (_pass_unavailableAuthorNames = pass.unavailableAuthorNames) !== null && _pass_unavailableAuthorNames !== void 0 ? _pass_unavailableAuthorNames : ""
                },
                {
                    type: "출판사",
                    value: pass.availablePublisherNames
                },
                {
                    type: "상품종류",
                    value: SourceTypeWithString["handout"]
                }
            ];
        case PassCategory.Ticket:
            var _pass_subject1, _pass_unavailableAuthorNames1, _pass_availablePublisherNames;
            return [
                {
                    type: "과목",
                    value: (_pass_subject1 = pass.subject) !== null && _pass_subject1 !== void 0 ? _pass_subject1 : SubjectsWithString[pass.subjectCode]
                },
                {
                    type: "과정",
                    value: pass.availableCurriculumNames
                },
                {
                    type: "제외 저자",
                    value: (_pass_unavailableAuthorNames1 = pass.unavailableAuthorNames) !== null && _pass_unavailableAuthorNames1 !== void 0 ? _pass_unavailableAuthorNames1 : ""
                },
                {
                    type: "출판사",
                    value: (_pass_availablePublisherNames = pass.availablePublisherNames) !== null && _pass_availablePublisherNames !== void 0 ? _pass_availablePublisherNames : ""
                },
                {
                    type: "가격",
                    value: pass.deductionMethod === "count" ? "".concat(numberFormatter(pass.availableMinPrice), "원~\n								").concat(numberFormatter(pass.availableMaxPrice), "원 사이") : ""
                },
                {
                    type: "상품종류",
                    value: SourceTypeWithString["handout"]
                }
            ];
        case PassCategory.Expert:
        case PassCategory.ExpertSubscription:
            var _pass_subject2;
            return [
                {
                    type: "과목",
                    value: (_pass_subject2 = pass.subject) !== null && _pass_subject2 !== void 0 ? _pass_subject2 : SubjectsWithString[pass.subjectCode]
                },
                {
                    type: "과정",
                    value: pass.availableCurriculumNames
                },
                {
                    type: "출판사",
                    value: pass.availablePublisherNames
                },
                {
                    type: "상품종류",
                    value: "엑스퍼트"
                }
            ];
        case PassCategory.FreePass:
            var _pass_subject3, _pass_availableAuthorNames;
            return [
                {
                    type: "과목",
                    value: (_pass_subject3 = pass.subject) !== null && _pass_subject3 !== void 0 ? _pass_subject3 : SubjectsWithString[pass.subjectCode]
                },
                {
                    type: "과정",
                    value: pass.availableCurriculumNames
                },
                {
                    type: "가능저자",
                    value: (_pass_availableAuthorNames = pass.availableAuthorNames) !== null && _pass_availableAuthorNames !== void 0 ? _pass_availableAuthorNames : ""
                },
                {
                    type: "출판사",
                    value: pass.availablePublisherNames
                },
                {
                    type: "상품종류",
                    value: SourceTypeWithString["handout"]
                }
            ];
        default:
            var _pass_subject4, _pass_unavailableAuthorNames2, _pass_availablePublisherNames1;
            //ticket 타입
            return [
                {
                    type: "과목",
                    value: (_pass_subject4 = pass.subject) !== null && _pass_subject4 !== void 0 ? _pass_subject4 : SubjectsWithString[pass.subjectCode]
                },
                {
                    type: "과정",
                    value: pass.availableCurriculumNames
                },
                {
                    type: "제외 저자",
                    value: (_pass_unavailableAuthorNames2 = pass.unavailableAuthorNames) !== null && _pass_unavailableAuthorNames2 !== void 0 ? _pass_unavailableAuthorNames2 : ""
                },
                {
                    type: "출판사",
                    value: (_pass_availablePublisherNames1 = pass.availablePublisherNames) !== null && _pass_availablePublisherNames1 !== void 0 ? _pass_availablePublisherNames1 : ""
                },
                {
                    type: "가격",
                    value: pass.deductionMethod === "count" ? "".concat(numberFormatter(pass.availableMinPrice), "원~\n								").concat(numberFormatter(pass.availableMaxPrice), "원 사이") : ""
                },
                {
                    type: "상품종류",
                    value: SourceTypeWithString["handout"]
                }
            ];
    }
};
